/** @format */

import {makeStyles} from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  title: {
    fontSize: 20,
    fontWeight: 400,
    lineHeight: '23px',
    marginBottom: theme.spacing(4),
  },
  text: {
    fontSize: 16,
    fontWeight: 400,
    [theme.breakpoints.down('sm')]: {
      lineHeight: '18px',
    },
    [theme.breakpoints.up('sm')]: {
      lineHeight: '20px',
    },
  },
  link: {
    color: '#8C8D8D',
    cursor: 'pointer',
    textDecoration: 'underline',
    verticalAlign: 'baseline',
  },
  hint: {
    color: '#8C8D8D',
  },
  selectWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: theme.spacing(4),
    marginRight: 0,
    borderRadius: '8px',
    background: '#202020',
    '&:last-of-type': {
      marginRight: '0',
    },
    [theme.breakpoints.up('sm')]: {
      width: 'calc(50% - 4px)',
      marginRight: theme.spacing(2),
      '&:last-of-type': {
        marginTop: theme.spacing(2),
      },
    },
  },
  row: {
    marginTop: theme.spacing(6),
    padding: theme.spacing(4),
    borderRadius: '8px',
    background: '#202020',
    '&:last-of-type': {
      marginTop: 0,
    },
  },
  tgBotTitle: {
    color: '#FFF',
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: 'normal',
    letterSpacing: '0.131px',
  },
  hintNew: {
    color: '#8B8B8B',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 'normal',
    letterSpacing: '0.131px',
  },
  linkNew: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(4, 8),
    borderRadius: '8px',
    background: '#2B2B2B',
    boxShadow: '1px 1px 5px 0px rgba(0, 0, 0, 0.05)',
    color: '#F1F1F1',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 'normal',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginTop: theme.spacing(4),
      justifyContent: 'center',
    },
  },
  selectTitle: {
    color: '#8B8B8B',
    fontSize: '14px',
    fontWeight: 400,
    letterSpacing: '0.131px',
  },
  selectItem: {
    marginTop: theme.spacing(4),
    '& .MuiSelect-selectMenu': {
      paddingLeft: theme.spacing(12),
      borderRadius: '8px',
      border: '1px solid #2B2B2B',
      background: 'transparent',
      color: '#FFF',
      fontSize: '14px',
      fontWeight: 400,
      letterSpacing: '0.131px',
    },
    '& .MuiSelect-icon': {
      color: '#fff',
    },
  },
  actionButton: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  actionButtonIcon: {
    marginRight: theme.spacing(2),
  },
  adTypesRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: theme.spacing(4),
    borderRadius: theme.spacing(2),
    background: '#202020',
    boxShadow: '1px 1px 5px 0px rgba(0, 0, 0, 0.05)',
  },
  adTypesContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    paddingLeft: theme.spacing(4),
  },
  adTypesTitle: {
    display: 'flex',
    alignItems: 'center',
    color: '#F1F1F1',
    fontSize: theme.spacing(5),
    fontWeight: 700,
    lineHeight: '26px',
    letterSpacing: '0.169px',
  },
  adTypesSettingsLink: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(4),
    padding: theme.spacing(4),
    borderRadius: theme.spacing(2),
    background: '#2B2B2B',
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginTop: theme.spacing(4),
      marginLeft: theme.spacing(0),
      justifyContent: 'center',
    },
  },
  adTypesSettingsLinkIcon: {
    marginRight: theme.spacing(2),
  },
  adTypesPlatforms: {
    padding: theme.spacing(4),
    borderRadius: theme.spacing(2),
    background: '#2B2B2B',
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
    },
  },
  groupsSelectorWrapper: {
    width: '100%',
    padding: theme.spacing(4),
    borderRadius: '8px',
    background: '#202020',
    boxShadow: '1px 1px 5px 0px rgba(0, 0, 0, 0.05)',
  },
  groupsTitle: {
    color: '#F1F1F1',
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: 'normal',
    letterSpacing: '0.131px',
  },
  groupsRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginTop: theme.spacing(4),
    gap: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.spacing(2),
    },
  },
  groupItem: {
    display: 'flex',
    alignItems: 'center',
    margin: 0,
  },
  groupItemDisabled: {
    opacity: 0.5,
  },
  groupLabel: {
    color: '#F1F1F1',
    fontSize: '14px',
    fontWeight: 400,
    letterSpacing: '0.131px',
  },
}));
